import React from "react";
import {
	Box,
	Image,
	Modal,
	ModalOverlay,
	ModalContent,
	ModalHeader,
	ModalFooter,
	ModalBody,
	ModalCloseButton,
	useDisclosure,
	Button,
	Text,
	useToast,
} from "@chakra-ui/react";
import { Raider } from "../../../types/raider";
import { nameCleanup } from "../../../util/helpers";
import { dismount } from "../../../util/web3/interactMounts";
import { Mount } from "../../../types/mount";

interface MountProps {
	raider: Raider;
	mount: Mount;
}

export default function MountPanel(props: MountProps) {
	const { mount, raider } = props;
	const { isOpen, onOpen, onClose } = useDisclosure();

	const toast = useToast();

	return (
		<>
			<Box>
				<Image
					src={mount.image}
					alt={mount.name}
					onClick={onOpen}
					cursor="pointer"
				/>
			</Box>
			<Modal isOpen={isOpen} onClose={onClose}>
				<ModalOverlay />
				<ModalContent>
					<ModalHeader>Dismount from {mount.name}?</ModalHeader>
					<ModalCloseButton />
					<ModalBody>
						<Text mb="10px">
							{nameCleanup(raider.name)} will lose their{" "}
							{(mount.attributes[3].value as number) - 100}% speed boost for gathering items
							on quests and returning home.
						</Text>
						<Text mb="10px">
							{mount.name} will return to your wallet for another Raider to use.
						</Text>
					</ModalBody>

					<ModalFooter>
						<Button
							colorScheme="blue"
							mr={3}
							onClick={() => dismount(parseInt(raider.id), toast)}
						>
							Dismount
						</Button>
					</ModalFooter>
				</ModalContent>
			</Modal>
		</>
	);
}
